module.exports = __webpack_public_path__ + "static/Diagram-2-88f84ebbe2d50650b211e625bef89aca.png";